<script lang="ts" module>
  import imgAssistantGood from '@/assets/assistant-good.png';
  import ContinueActionsComponent from '@/ui/components/continueActions/ContinueActionsComponent.svelte';
  import BaseCard from '@/ui/elements/card/BaseCard.svelte';
  import CardHeader from '@/ui/elements/card/CardHeader.svelte';

  export interface DoneCardProps {
    cardLabel: string;
  }
</script>

<script lang="ts">
  let { ...props }: DoneCardProps = $props();
</script>

<BaseCard>
  {#snippet header()}
    <CardHeader {...props}></CardHeader>
  {/snippet}
  <div class="mb-2 overflow-hidden rounded-sm">
    <img src={imgAssistantGood} role="presentation" alt="Celebration" class="w-full" />
    <p class=" bg-prim p-3 font-sans text-label-sm font-normal text-c-base">
      Alles in Ordnung, nichts mehr zu tun! Du hast einen sehr guten TPI-Wert erreicht!
    </p>
  </div>
  <div class="grid gap-3">
    <ContinueActionsComponent
      actions={['newText', 'brandScanner', 'spellCheck', 'performanceReport']}
    />
  </div>
</BaseCard>
